const LIVE_PORTAL_HOSTNAME = 'live.dohockey.app';

export const isLivePortalHostname = (hostname: string): boolean =>
  hostname.trim().toLowerCase() === LIVE_PORTAL_HOSTNAME;
